<div class="breadcrumbGlobal">
    <a [routerLink]="['/mydashboard']">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/technical-support/technical-support']">
        <span translate>COMMONS.TECHNICAL_SUPPORT</span>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <span translate>COMMONS.PASSKEY_OTP</span>
</div>

<tb-header specificTitle="COMMONS.PASSKEY_OTP_GENERATION"></tb-header>

<div class="contentGlobal">
  <mat-card class="course-card course-card--filters" style="text-align: right;">
    <mat-card-header>
      <mat-card-title><span translate>COMMONS.GENERATE</span> OTP</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="text-left" [innerHtml]="this.passKeyIntroduction"></div>
      <div class="filters-container" style="margin-top: 3rem" >
        <mat-form-field appearance="outline" [formGroup]="search">
          <mat-label><span translate>COMMONS.SELECT_PRODUCT</span></mat-label>
          <mat-select formControlName="productCode">
            <mat-option *ngFor="let product of productsDescription" [value]="product.code">{{product.description}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <button [disabled]="disableButton()" mat-flat-button color="primary" (click)="generateOTPToken()">
        <span translate>COMMONS.PASSKEY_OTP_GENERATE</span>
      </button>
    </mat-card-content>
  </mat-card>
</div>
